<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar :tabbarIndex="0" :goodsNumber="goodsNumber"></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main">
      <div class="df-goodshow">
        <div class="df-spzx-da" style="padding-top:20px;">
          <div class="df-maina-ddtit"><span>产品详情</span></div>
          <div
            :class="index == butsIndex ? 'df-spzx-dabox on' : 'df-spzx-dabox'"
            @click="clickedBtns(index)"
            v-for="(item, index) of btns"
            :key="index"
          >
            <div class="df-spzx-dam">{{ item.name }}</div>
            <div class="df-spzx-daico"></div>
          </div>
        </div>
        <div class="df-goodshow-b">
          <div class="df-goodshow-ba">
            <img
              v-if="currentPageInfo.pcImg"
              :src="currentPageInfo.pcImg"
              class="img"
            /><img v-else src="../../images/image.png" class="img" />
          </div>
          <div class="df-goodshow-bb">
            <h2>{{ currentPageInfo.goodsName }}</h2>
            
            <!-- <p>生产厂家：无字段</p> -->
            <p>
              商品SKU：{{ currentPageInfo.goodsCode }}
              <span
                class="copy hands"
                @click="copyText(currentPageInfo.goodsCode)"
              >
                复制
              </span>
            </p>
            <p>商品型号：{{ currentPageInfo.goodsModel || "" }}</p>
            <!--<p>商品重量：{{ currentPageInfo.weight || 0 }} kg</p>
            <p>商品体积：{{ currentPageInfo.volume || 0 }} cm³</p>
            <p>保质期：无字段</p>
            <p>发票税点：无字段</p>
            <p>既往排名：无字段</p>
            <p>应用场景：无字段</p> -->
            <p>库存：{{ currentPageInfo.goodsStock || "--" }}</p>
            <h3>
              分销价：{{ to_f(currentPageInfo.shopPrice) || "--" }}元/{{
                currentPageInfo.units
              }}
            </h3>
            <h3>
              建议零售价：{{ to_f(currentPageInfo.marketPrice) || "--" }}元/{{
                currentPageInfo.units
              }}
            </h3>
            <el-button
              @click="addCart(1, currentPageInfo.goodsId)"
              icon="el-icon-shopping-cart-full"
              class="df-tobay"
              style="background:#4ea5db"
              circle
            ></el-button>
          </div>
        </div>
      </div>
      <div class="df-goodshow-bc"><span>商品介绍</span></div>
      <div v-html="currentPageInfo.pcDetail" class="df-goodshow-bd"></div>

      <!--<div class="top">
        <span class="text">商品详情</span>
        <div class="sj"></div>
      </div>
      <div v-if="!cc" class="goodInfo borderShadow">
        <div class="left borderShadow">
          <img
            v-if="currentPageInfo.pcImg"
            :src="currentPageInfo.pcImg"
            class="img"
          /><img v-else src="../../images/image.png" class="img" />
          <div class="cc">
            <div class="item">
              <img src="../../images/image.png" class="img1" />
            </div>
            <div class="item">
              <img src="../../images/image.png" class="img1" />
            </div>
            <div class="item">
              <img src="../../images/image.png" class="img1" />
            </div>
            <div class="item">
              <img src="../../images/image.png" class="img1" />
            </div>
          </div>
        </div>
        <div class="right">         
          <el-row :gutter="24">
            <el-col :span="20">
              <div style="padding:15px 5px;">
                <span style="font-size:16px;font-weight:bold;">{{
                  currentPageInfo.goodsName
                }}</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div style="padding:15px 5px;"></div>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="5">
              <div style="padding:15px 5px;">
                <span style="font-size:13px;font-weight:bold;">
                  商品SKU:{{currentPageInfo.goodsCode}}</span>
              </div>
            </el-col>
            <el-col :span="4">
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="5">
              <div style="padding:15px 5px;">
                <span style="font-size:13px;">
                  商品规格:{{currentPageInfo.goodsCode}}</span>
              </div>
            </el-col>
            <el-col :span="4">
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="20">
              <div style="padding:15px 5px;">
                <span style="font-size:13px;">价格：{{
                  currentPageInfo.marketPrice
                }}</span>
              </div>
            </el-col>
            <el-col :span="4">
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="bottom borderShadow">
        <div class="images">
          <div class="left">
            <img
              v-if="currentPageInfo.pcImg"
              :src="currentPageInfo.pcImg"
              class="img"
            />
            <img v-else src="../../images/image.png" class="img" />
          </div>
          <div class="right">
            <div :class="chooseImgIndex == 0 ? 'item item-on' : 'item'">
              <img
                v-if="currentPageInfo.pcImg"
                :src="currentPageInfo.pcImg"
                class="img"
              />
              <img v-else src="../../images/image.png" class="img" />
            </div>
          </div>
        </div>
        <div class="info">
          <div class="top">商品信息</div>
          <div class="bottom">
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">创建时间:</div>
                <div class="right">{{ currentPageInfo.createTime }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">商品状态:</div>
                <div class="right right1">
                  <span v-if="currentPageInfo.status == 0">上架</span>
                  <span v-else-if="currentPageInfo.status == 1">下架</span>
                  <span v-else-if="currentPageInfo.status == 2">停售</span>
                  <span v-else-if="currentPageInfo.status == 3"
                    >修改申请中</span
                  >
                  <span v-else-if="currentPageInfo.status == 4"
                    >下架申请中</span
                  >
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">商品名称:</div>
                <div class="right">{{ currentPageInfo.goodsName }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">商品SKU:</div>
                <div class="right">{{ currentPageInfo.goodsCode }}</div>
                <div
                  class="copy hands"
                  @click="copyText(currentPageInfo.goodsCode)"
                >
                  复制
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div class="info">
          <div class="top">重量信息</div>
          <div class="bottom">
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">商品条码:</div>
                <div class="right">{{ currentPageInfo.goodsBar }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">商品体积:</div>
                <div class="right">{{ currentPageInfo.volume || 0 }}m3</div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">商品重量:</div>
                <div class="right">{{ currentPageInfo.weight || 0 }}KG</div>
              </div>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="top">价格信息</div>
          <div class="bottom">
            <div class="line line2 flexStyle2">
              <div class="item item2 flexStyle2">
                <div class="left">市场价格:</div>
                <div class="right">¥{{ currentPageInfo.marketPrice }}</div>
              </div>
              <div class="item item2 flexStyle2">
                <div class="left">创建人:</div>
                <div class="right">{{ currentPageInfo.createName }}</div>
              </div>
              <div class="item item2 flexStyle2">
                <div class="left">修改人:</div>
                <div class="right">{{ currentPageInfo.updateName }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="top">商品介绍</div>
          <div class="bottom">{{ currentPageInfo.pcInfo || "" }}</div>
        </div>
      </div>

      <div class="goBack">
        <el-button
          icon="el-icon-back"
          type="primary"
          size="small"
          style="width:90px;"
          @click="goBack"
        >
          返 回
        </el-button>
      </div>-->
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import {
  goodsDetailRequest,
  addCartRequest,
  shoppingCarNumber,
} from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      currentPageInfo: {}, // 1.1.currentPageInfo
      goodsId: "", // 1.2.goodsId
      token: "", // 1.3.token
      chooseImgIndex: 0, // 1.4.选中商品图index
      cc: true,
      btns: [
        // 1.1.buttons
        { name: "商品列表", id: 1 },
        { name: "定制产品组合", id: 2 },
        { name: "项目产品组合", id: 3 },
        { name: "定制大礼包", id: 4 },
        { name: "礼册产品组合", id: 5 },
        // {name: '公共套餐', id: 6},
      ],
      obj: null,
      butsIndex: 0,
      goodsNumber: 0,
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.tabbar
    cFooter: footer, // 2.2.footer
  },

  methods: {
    // 3.methods
    copyText(value) {
      // 3.1.copyText
      let inputObject = document.createElement("input");
      document.body.appendChild(inputObject);
      inputObject.style.visibility = "none";
      inputObject.value = value;
      inputObject.select();
      document.execCommand("copy");

      this.$message({
        showClose: true,
        message: "已复制到剪切板",
        type: "success",
      });
      inputObject.style.display = "none";
    },

    goBack() {
      // 3.2.返回
      this.$router.go(-1);
    },

    addCart(index, row) {
      let data = {
        index: index,
        goodsId: row.goodsId,
        amount: 1,
      };
      addCartRequest(data).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: "成功加入购物车",
          });
          this.$emit("addSuccess");
        }
      });
    },

    getGoodsNumber() {
      // 3.2.获取购物车信息
      shoppingCarNumber().then((res) => {
        if (res) {
          this.goodsNumber = res.data;
        }
      });
    },

    addSuccess() {
      // 3.3.添加购车成功
      this.getGoodsNumber();
    },

    getCurrentPageInfo() {
      // 3.3.获取商品信息
      goodsDetailRequest(this.goodsId).then((res) => {
        if (res) {
          this.currentPageInfo = res.data || {};
          //console.log("商品信息：", this.currentPageInfo);
        }
      });
    },

    clickedBtns(index) {
      this.$router.push({
        path: "/goodsCenter",
        query: { index: index, pobj: JSON.stringify(this.btns[index]) },
      });
      this.butsIndex = index;
    },
  },

  mounted() {
    if (this.$route.query.obj) {
      // this.currentPageInfo = JSON.parse(this.$route.query.obj);
      this.goodsId = JSON.parse(this.$route.query.obj).goodsId;
      if (localStorage.token) {
        this.token = localStorage.token;
        this.getCurrentPageInfo();
      }
    }
    this.getGoodsNumber();
  },
};
</script>

<style scoped lang="scss">
@import "./goodsDetail.scss";
</style>
<style>
.el-carousel__button {
  display: none;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.imgList {
  width: 450px;
  height: 100px;
  margin-top: 20px;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
